export default __webpack_public_path__ + "media/images/landlords_page/benefits_3-9fed1b7366b917ea7404106e62dda615.png";